module.exports = __webpack_public_path__ + "static/media/payping.3415300c.svg";